import React, { useState, useEffect, useRef } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";

const PageHeader = ({ title, backgroundImage, breadcrumb }) => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  const handleDropdownToggle = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  const handleClickOutside = (event) => {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setIsDropdownOpen(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const buildBreadcrumbSchema = () => {
    const itemListElement = [];
    let position = 1;

    breadcrumb.forEach((item) => {
      if (item.dropdown) {
        const currentLabel = item.label;
        const currentPath = item.dropdown.find(
          (d) => d.label === currentLabel,
        )?.path;
        if (currentPath) {
          itemListElement.push({
            "@type": "ListItem",
            position: position++,
            name: currentLabel,
            item: `https://www.inissoft.com${currentPath}`,
          });
        }
        item.dropdown.forEach((d) => {
          if (d.label !== currentLabel) {
            itemListElement.push({
              "@type": "ListItem",
              position: position++,
              name: d.label,
              item: `https://www.inissoft.com${d.path || ""}`,
            });
          }
        });
      } else {
        itemListElement.push({
          "@type": "ListItem",
          position: position++,
          name: item.label,
          item: item.path ? `https://www.inissoft.com${item.path}` : undefined,
        });
      }
    });

    return {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement,
    };
  };

  const breadcrumbSchema = breadcrumb ? buildBreadcrumbSchema() : null;

  return (
    <>
      {/* {breadcrumbSchema && (
                <Helmet>
                    <script type="application/ld+json">
                        {JSON.stringify(breadcrumbSchema)}
                    </script>
                </Helmet>
            )} */}
      <div
        className="content-header"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        <h1 className="title">{title}</h1>
        <div className="container">
          <ul className="breadcrumb">
            {breadcrumb.map((item, index) => (
              <li key={index} className="breadcrumb-item">
                {index === 0 ? (
                  <Link to={item.path || "/main"} className="btn home">
                    <span className="blind">{item.label}</span>
                  </Link>
                ) : item.dropdown ? (
                  <div className="dropdown" ref={dropdownRef}>
                    <button onClick={handleDropdownToggle} className="btn path">
                      {item.label}
                    </button>

                    {isDropdownOpen && (
                      <ul className="dropdown-menu">
                        {item.dropdown.map((dropdownItem, idx) => (
                          <li
                            key={idx}
                            onClick={() => {
                              setIsDropdownOpen(false);
                              dropdownItem.onClick();
                            }}
                          >
                            {dropdownItem.label}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                ) : (
                  <span>{item.label}</span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </>
  );
};

export default PageHeader;
